<template>
    <div v-show="!hideSection" class="cpg-list-wrapper w-100">
        <p v-if="campaignsData" class="list-title"> {{kStrings.kAVAILABLE_OFFERS}} </p>
        <div v-if="campaignsData" class="campaign-list" ref="campaignListContainer" id="campaignListContainer">
            <div class="cpg-item" v-for="cpg in campaignsData" :key="cpg.coupon">
                <div class="cpg-name">
                    <span class="coupon-name"> {{cpg.couponId | strippedContent}} </span>
                    <span v-if="cpg.type == 'coupon'" class="coupon-title">{{cpg.labelHtml.toLowerCase().trim() | strippedContent}} </span>
                </div>
                <div v-if="cpg.counter" class="cpg-timer">
                    <i class="prz-time"/>
                    <Counter :date="cpg.dateEnd" :useDays="false"/>
                </div>
                <div class="actions">
                    <CopyToClipboard v-if="cpg.type == 'coupon'" :value="cpg.couponId" :k-strings="kStrings" @input="copied(cpg)" />
                    <i class="prz-info" @click="cpgDetailData = cpg, $emit('open-fp')"/>
                </div>
            </div>
            <transition name="fade">
                <!-- detail fs modal -->
                <BlockContentPopup
                    v-if="cpgDetailData"
                    id="blockContentPopup"
                    class="cpg-popup"
                    :modal-mode="true"
                    :stacked-modal="true"
                    @close="closeModal()"
                >
                    <template v-slot:content>
                        <CampaignDisplay v-if="cpgDetailData" :campaign="cpgDetailData" :k-strings="kStrings" :stacked-modal="true" @close="closeModal()"/>
                    </template>
                </BlockContentPopup>
            </transition>
        </div>
<!--        <div v-else class="campaign-list">
            <div class="cpg-item skeleton-box"/>
        </div>-->
    </div>
</template>
<script>

import {storePdp} from '@/store/product-page';
import pdpEvents from '@/Utilities/events-pdp/events';
import {isEmpty} from "lodash-es";
import Counter from '@/components/Muffin/Counter';
import CopyToClipboard from '@/components/Muffin/CopyToClipboard';
export default {
    storePdp,
    name: 'CampaignList',
    components:{
        Counter,
        CopyToClipboard,
        BlockContentPopup: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/BlockContentPopup.vue'),
        CampaignDisplay: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/CampaignDisplay.vue'),
    },
    props: {
        loadOnCreate: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return{
            loading: false,
            cpgDetailData: null, // cpg details modal
        }
    },
    created() {
        if(this.loadOnCreate){
            this.load();
        }
    },
    computed: {
        storeKStrings() {
            return storePdp.getters['pdpDesktop/kStrings'];
        },
        kStrings() {
            if(!this.campaignsData) {
                return {};
            }

            const data = storePdp.getters['pdpDesktop/campaignsData'];
            return data.kSTRINGS;
        },
        campaignsConnection() {
            return storePdp.getters['pdpDesktop/campaignsConnection'];
        },
        campaignsData() {
            const data = storePdp.getters['pdpDesktop/campaignsData'];
            return !isEmpty(data) && !isEmpty(data.campaigns) ? data.campaigns : null;
        },
        hideSection() {
            return isEmpty(this.campaignsData);
        }
    },
    methods: {
        async load() {
            this.loading = true;
            await storePdp.dispatch('pdpDesktop/updateCampaignsData', this.campaignsConnection);
            this.loading = false;
        },
        viewed(value, campaign){
            if(value){
                pdpEvents.addCampaignViewed(campaign);
            }
        },
        copied(campaign){
            pdpEvents.addCampaignCouponCopied(campaign);
        },
        closeModal() {
            this.cpgDetailData = null;
            this.$emit('close-fp');
        }
    },
    filters: {
        strippedContent: function(string) {
            return string ? string.replace(/<\/?[^>]+>/ig, " ") : ''; 
        }
    },
}
</script>
<style lang="scss">
@import "./styles/cpgList";
</style>
